import { DragOutlined } from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

export const SeqWorkspaceItem = ({ id, text }: any) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id }) // Передаем уникальный id элемента

  const style: any = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: '16px',
    margin: '8px 0',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: isDragging ? '#e2e8f0' : '#ffffff',
    border: '1px solid #cbd5e1',
    borderRadius: '6px',
    boxShadow: isDragging ? '0 10px 15px -3px rgba(0, 0, 0, 0.1)' : 'none',
    cursor: 'grab',
    userSelect: 'none',
    opacity: isDragging ? 0.6 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      {text}
      <DragOutlined />
    </div>
  )
}
